<template>
  <SelectableSearch
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    :options="props.options"
    idKey="id"
    labelKey="in_charge_last_nm"
    :formatter="props.formatter || defaultFormatLabel"
    :getInputLabel="(rep) => {
      const customer = rep?.m_customer?.customer_nm ?? ''
      const dept = rep?.in_charge_department_nm ?? ''
      const fullName = `${rep?.in_charge_last_nm ?? ''} ${rep?.in_charge_first_nm ?? ''}`.trim()
      return `${customer} ${dept} ${fullName}`.trim()
    }"
    :placeholder="props.placeholder || '顧客担当者で検索'"
    :required="props.required || false"
    :normalize-width="props.normalizeWidth"
  />
</template>

<script setup>
import SelectableSearch from './SelectableSearch.vue'

const props = defineProps({
  modelValue: [String, Number, null],
  options: {
    type: Array,
    required: true
  },
  formatter: Function,
  placeholder: String,
  required: Boolean,
  normalizeWidth: Boolean
})

const emit = defineEmits(['update:modelValue'])

const defaultFormatLabel = (rep) => {
  const customer = rep?.m_customer?.customer_nm ?? ''
  const dept = rep?.in_charge_department_nm ?? ''
  const fullName = `${rep?.in_charge_last_nm ?? ''} ${rep?.in_charge_first_nm ?? ''}`.trim()

  // 何もなければ fallback 表示
  if (!customer && !dept && !fullName) return `ID: ${rep?.id}`

  return `${customer} ${dept} ${fullName}（ID: ${rep?.id ?? ''}）`.trim()
}
</script>
